export default "__VITE_ASSET__B793Y$6A__"